<div [formGroup]="entityForm" fxLayout="row" fxLayoutAlign="space-between center" class="di-modal-title">
    <h2 fxFlex="33">
        {{ 'exportSettings.pages.exportSettings.heading' | translate }}
    </h2>
    <div fxLayout="row" fxLayoutAlign="end center" fxFlex="67">
        <button
            *ngIf="modalData.allowCustomColumns !== false"
            nz-button
            nzType="link"
            (click)="this.addEmptyExportSetting()"
            style="margin-right: 20px">
            <i nz-icon nzType="plus"></i>
        </button>
        <di-select
            [grow]="false"
            fxFlex="50"
            field="exportType"
            [options$]="exportTypes$"
            valueAttribute="value"
            displayAttribute="label"
            [suppressLabel]="true"
            [allowClear]="false"
            (selectionChange)="loadExportSettings()">
        </di-select>
    </div>
</div>
<div class="di-modal-body">
    <div class="w-100-p" style="max-height: 480px" fxLayout="column" [perfectScrollbar]="$any(undefined)">
        <nz-alert
            *ngIf="includeError"
            nzType="error"
            nzMessage="Error"
            nzDescription="{{ 'exportSettings.messages.includeAtleastOneFieldForExport.message' | translate }}"></nz-alert>
        <div [formGroup]="writeSettingsForm" fxLayout="column" class="mb-4">
            <div class="pl-24">
                <div class="mpos-form-row" *ngFor="let setting of readSettings; let i = index">
                    <div fxFlex="50%" fxLayoutAlign="start center" *ngIf="setting.enabled">
                        <h4 [ngClass]="{childSetting: setting.parentSetting}">
                            {{ 'exportSettings.scopes.exportSettingsForm.fields.otherSettings.' + setting.key + '.label' | translate }}
                        </h4>
                    </div>
                    <div fxFlex="25%" fxLayoutAlign="start center" *ngIf="setting.enabled">
                        <label nz-checkbox *ngIf="setting.valueType === 'BOOLEAN'" formControlName="{{ setting.key }}"> </label>
                        <di-input *ngIf="setting.valueType === 'STRING'" field="{{ setting.key }}" [suppressLabel]="true"></di-input>
                        <di-input
                            *ngIf="setting.valueType === 'INTEGER' || setting.valueType === 'DECIMAL'"
                            type="number"
                            field="{{ setting.key }}"
                            [suppressLabel]="true">
                        </di-input>
                        <di-time *ngIf="setting.valueType === 'TIME'" field="{{ setting.key }}" [suppressLabel]="true"></di-time>
                        <di-date *ngIf="setting.valueType === 'DATE'" field="{{ setting.key }}" [suppressLabel]="true"></di-date>
                    </div>
                </div>
            </div>
        </div>
        <div mposForm="exportSettingsForm" [formGroup]="exportSettingsForm | asFormGroup" fxLayout="column" fxFlex>
            <nz-table
                cdkDropList
                (cdkDropListDropped)="drop($event)"
                [nzShowPagination]="false"
                [nzData]="exportSettingsForm.value"
                nzSize="small"
                [nzLoading]="loading">
                <thead>
                    <tr>
                        <th nzWidth="5px"></th>
                        <th>{{ 'exportSettings.pages.exportSettings.columns.defaultColumnName' | translate }}</th>
                        <th>{{ 'exportSettings.pages.exportSettings.columns.userColumnName' | translate }}</th>
                        <th>{{ 'exportSettings.pages.exportSettings.columns.include' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-settingForm [ngForOf]="exportSettingsForm.controls">
                        <tr [formGroup]="settingForm | asFormGroup" class="no-margin" cdkDrag>
                            <td><span cdkDragHandle nz-icon nzType="drag" nzTheme="outline"></span></td>
                            <td><di-input [readonly]="true" field="defaultColumnName" [suppressLabel]="true"></di-input></td>
                            <td><di-input field="userColumnName" [suppressLabel]="true"></di-input></td>
                            <td><di-checkbox field="include" [suppressLabel]="true"></di-checkbox></td>
                        </tr>
                    </ng-template>
                </tbody>
            </nz-table>
        </div>
    </div>
</div>
<div fxLayout="row" fxLayoutAlign="end center" class="mb-0 di-modal-actions">
    <button nz-button nzType="default" (click)="modal.close()">{{ 'exportSettings.pages.createEdit.buttons.cancel' | translate }}</button>
    <button nz-button nzType="primary" class="ml-12" [disabled]="addDisabled$ | async" (click)="saveSettings()">
        {{ 'exportSettings.pages.createEdit.buttons.save' | translate }}
    </button>
</div>
